import { IconButton, IconButtonProps, CircularProgress } from "@mui/material";
import { useFormContext } from "../../../contexts/form-context";
import { useStore } from "@tanstack/react-form";
import { useSubmitButton } from "../../../modules/field-set";

export default function FormSubmitIconButton({
    name,
    children,
    ...props
}: IconButtonProps) {
    const form = useFormContext();
    const submit = useSubmitButton({ name });

    const [isSubmitting, canSubmit] = useStore(form.store, state => [state.isSubmitting, state.canSubmit])

    const disabled = submit.fieldSet.disabled || isSubmitting || !canSubmit || props.disabled;
    const loading = isSubmitting && submit.isSubmitting

    return <IconButton
        {...props}
        ref={submit.ref as any}
        onClick={e => {
            props.onClick && props.onClick(e);
            if (!e.defaultPrevented) submit.submit();
        }}
        disabled={disabled}
        sx={{ position: "relative", ...props.sx }}
    >
        {loading ? <CircularProgress size={"25px"} /> : children}
    </IconButton>
}